import React from 'react';
import "./overlay.css";

const Overlay = () => {
  return (
    <div className='overlay'></div>
  )
}

export default Overlay